'use strict';

var network = require('./network.js');

class BadResponseError extends network.NetworkError {
}

exports.BadResponseError = BadResponseError;
//# sourceMappingURL=bad_response.js.map
